import { Injectable, computed, signal } from "@angular/core";

/**
 * Tracks whether a bulk operation is mutating cards, so views can suppress per-card
 * refreshes while it runs and do a single refresh at the end.
 *
 * This used to ride on `AuthService.longOperationEmitter`, which coupled the grid to
 * auth and meant neither concern could change independently. Session keepalive is a
 * separate concern -- see LongOperationService / SessionKeepaliveService.
 */
@Injectable({ providedIn: "root" })
export class BulkOperationService {
    private readonly activeCount = signal(0);

    /** True while at least one bulk operation is in flight. */
    public readonly suppressCardRefresh = computed(() => this.activeCount() > 0);

    public begin(): void {
        this.activeCount.update((n) => n + 1);
    }

    public end(): void {
        this.activeCount.update((n) => Math.max(0, n - 1));
    }
}
